<template>
  <div
    class="new-project-container"
    :class="{
      'new-project-container-side-panel': this.$route.name !== 'newCompany',
    }"
  >
    <div class="new-project-header">
      <div class="title-and-excell">
        <h2 class="title" v-if="this.$route.name === 'newCompany'">
          {{ $t("create-new-company") }}
        </h2>
      </div>

      <div class="buttons-wrapper">
        <!-- <div class="switch-wrapper" v-if="selectedPart !== undefined">
          <label
            class="switch-label"
            :class="{
              'switch-label-active':
                !company.objects[selectedObject].parts[selectedPart].isActive,
            }"
            @click="
              company.objects[selectedObject].parts[
                selectedPart
              ].isActive = false
            "
            >{{ $t("inactive-site") }}</label
          >
          <div class="switch-container">
            <label class="switch">
              <input
                type="checkbox"
                v-model="
                  company.objects[selectedObject].parts[selectedPart].isActive
                "
                @change="companyChanged()"
              />
              <span class="slider"></span>
            </label>
          </div>
          <label
            class="switch-label"
            :class="{
              'switch-label-active':
                company.objects[selectedObject].parts[selectedPart].isActive,
            }"
            @click="
              company.objects[selectedObject].parts[
                selectedPart
              ].isActive = true
            "
            >{{ $t("active-site") }}</label
          >
        </div> -->
        <!-- <div class="switch-wrapper" v-else>
          <label
            class="switch-label"
            :class="{ 'switch-label-active': !newPart.isActive }"
            @click="newPart.isActive = false"
            >{{ $t("inactive-site") }}</label
          >
          <div class="switch-container">
            <label class="switch">
              <input
                type="checkbox"
                v-model="newPart.isActive"
                @change="companyChanged()"
              />
              <span class="slider"></span>
            </label>
          </div>
          <label
            class="switch-label"
            :class="{ 'switch-label-active': newPart.isActive }"
            @click="newPart.isActive = true"
            >{{ $t("active-site") }}</label
          >
        </div> -->
        <button class="btn btn-close desktop" @click="goBack">
          <span class="tms">F</span>
          {{ $t("cancel") }}
        </button>
        <button class="btn btn-new desktop" @click="save()">
          <span class="tms">Y</span>
          {{ $t("save") }}
        </button>
      </div>
    </div>

    <!-- NEW COMPANY CONTENT -->
    <div class="new-wrapper">
      <!-- :class="{ 'new-wrapper--inactive': !isObjectActive() }" -->
      <div class="new-content">
        <!-- ROW 1 -->
        <div class="new-content-inputs new-content-inputs--top">
          <div class="inputs">
            <!-- ИМЕ НА ФИРМА -->
            <div class="new-input-wrapper">
              <label for="newCompany">
                <strong>{{ $t("company") }}*</strong>
              </label>
              <div class="new-input">
                <span class="tms">Z</span>
                <input
                  v-if="!company._id"
                  type="text"
                  :placeholder="$t('company-name')"
                  @focus="getCompanies(), openDropdown(0)"
                  @blur="closeDropdown(0)"
                  v-model="searchCompanies"
                  @change="companyChanged()"
                  :disabled="
                    company.companyName.length ||
                    this.$route.name === 'newObject' ||
                    this.$route.name === 'newPart' ||
                    this.$route.name === 'newPartOLD' ||
                    this.$route.name === 'getPart'
                  "
                />
                <input
                  v-else
                  type="text"
                  :placeholder="$t('company-name')"
                  @focus="getCompanies(), openDropdown(0)"
                  v-model="company.companyName"
                  @blur="closeDropdown(0)"
                  :disabled="
                    company.companyName.length ||
                    this.$route.name === 'newObject' ||
                    this.$route.name === 'newPart' ||
                    this.$route.name === 'newPartOLD' ||
                    this.$route.name === 'getPart'
                  "
                />
                <span
                  v-if="
                    company.companyName.length &&
                    !(
                      this.$route.name === 'newObject' ||
                      this.$route.name === 'newPart' ||
                      this.$route.name === 'newPartOLD' ||
                      this.$route.name === 'getPart'
                    )
                  "
                  class="clear"
                  @click="resetSelectedCompany()"
                  >F</span
                >
                <template
                  v-if="
                    this.$route.name === 'newObject' ||
                    this.$route.name === 'newPart' ||
                    this.$route.name === 'newPartOLD' ||
                    this.$route.name === 'getPart'
                  "
                >
                  <span
                    class="edit"
                    @click="
                      toggleEdit(
                        company.companyName,
                        'company',
                        company.shortName
                      )
                    "
                    >c</span
                  >
                  <span class="disabled">A</span>
                </template>
              </div>
              <div
                class="new-input-dropdown"
                :class="{ 'new-input-dropdown-active': openedDropdown[0] }"
              >
                <ul v-if="companies.length">
                  <li
                    v-for="c in filteredCompanies()"
                    :key="c._id"
                    @mousedown="selectCompany(c._id), companyChanged()"
                  >
                    {{ c.companyName }}
                  </li>
                </ul>
              </div>
            </div>
            <!-- ИМЕ НА ОБЕКТ-->
            <div class="new-input-wrapper">
              <label for>
                <strong>{{ $t("site") }}*</strong>
              </label>
              <div class="new-input">
                <span class="tms">Z</span>
                <input
                  v-if="selectedObject === undefined"
                  type="text"
                  :placeholder="$t('site-name')"
                  @focus="openDropdown(2)"
                  @blur="closeDropdown(2)"
                  v-model="searchObjects"
                  @change="companyChanged()"
                  :disabled="
                    selectedObject !== undefined ||
                    this.$route.name === 'newPartOLD' ||
                    this.$route.name === 'getPart'
                  "
                />
                <input
                  v-else
                  type="text"
                  :placeholder="$t('site-name')"
                  @focus="openDropdown(2)"
                  @blur="closeDropdown(2)"
                  v-model="company.objects[selectedObject].objectName"
                  :disabled="
                    selectedObject !== undefined ||
                    this.$route.name === 'newPartOLD' ||
                    this.$route.name === 'getPart'
                  "
                />
                <span
                  v-if="
                    (selectedObject !== undefined &&
                      this.$route.name !== 'newPartOLD') ||
                    this.$route.name === 'getPart'
                  "
                  class="clear"
                  @click="resetSelectedObject()"
                  >F</span
                >
                <template
                  v-if="
                    this.$route.name === 'newPartOLD' ||
                    this.$route.name === 'getPart'
                  "
                >
                  <span
                    class="edit"
                    @click="
                      toggleEdit(
                        company.objects[selectedObject].objectName,
                        'object',
                        company.objects[selectedObject].shortName
                      )
                    "
                    >c</span
                  >
                  <span class="disabled">A</span>
                </template>
                <!-- <span class="disabled">A</span> -->
              </div>
              <div
                class="new-input-dropdown"
                :class="{ 'new-input-dropdown-active': openedDropdown[2] }"
              >
                <ul v-if="company._id">
                  <li
                    v-for="(o, index) in filteredObjects()"
                    :key="o._id"
                    @mousedown="selectObject(index), companyChanged()"
                  >
                    {{ o.objectName }}
                  </li>
                </ul>
              </div>
            </div>
            <!-- ИМЕ НА ЧАСТ-->
            <div class="new-input-wrapper" v-if="!company._id">
              <!-- ||
                (this.company._id &&
                  this.selectedObject === undefined &&
                  searchObjects) -->
              <label for>
                <strong>{{ $t("part") }}*</strong>
              </label>
              <div class="new-input">
                <span class="tms">Z</span>
                <input
                  v-if="selectedPart === undefined"
                  type="text"
                  :placeholder="$t('part-name')"
                  @focus="openDropdown(3)"
                  @blur="closeDropdown(3)"
                  v-model="searchParts"
                  @change="companyChanged()"
                />
                <input
                  v-else-if="
                    company.objects[selectedObject].parts[selectedPart]
                  "
                  type="text"
                  :placeholder="$t('part-name')"
                  @focus="openDropdown(3), resetSelectedPart()"
                  @blur="closeDropdown(3)"
                  v-model="
                    company.objects[selectedObject].parts[selectedPart].partName
                  "
                  :disabled="
                    selectedPart !== undefined || this.$route.name === 'getPart'
                  "
                />
                <span
                  v-if="selectedPart !== undefined"
                  class="clear"
                  @click="resetSelectedPart()"
                  >F</span
                >
                <template v-if="this.$route.name === 'getPart'">
                  <span
                    class="edit"
                    @click="
                      toggleEdit(
                        company.objects[selectedObject].parts[selectedPart]
                          .partName,
                        'part'
                      )
                    "
                    >c</span
                  >
                  <span class="disabled delete" @click="deletePart()">b</span>
                </template>
              </div>
              <div
                class="new-input-dropdown"
                :class="{ 'new-input-dropdown-active': openedDropdown[3] }"
              >
                <ul v-if="selectedObject !== undefined">
                  <li
                    v-for="(p, index) in filteredParts()"
                    :key="p._id"
                    @mousedown="selectPart(index), companyChanged()"
                  >
                    {{ p.partName }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div
            class="new-content-data-row new-content-data-row-fullsize new-content-data-row-full-height"
            v-if="viewLists()"
            :class="{ 'new-content-data-row-active': viewLists() }"
          >
            <!-- REPORTERS -->
            <div
              class="new-content-data-item"
              @click="isAddUsersModalOpened = true"
            >
              <div
                class="banner"
                :class="{
                  'banner--hidden': getReportersForModal().length,
                }"
              >
                <span class="tms">#</span>
                <p>
                  {{ getReportersForModal().length ? "Редактирай" : "Добави" }}
                  Ръководител обект и отчетници към обекта
                </p>
              </div>
              <div v-if="viewLists()" class="new-content-data-item-content">
                <div class="new-content-data-item-content-lists">
                  <!-- <template v-if="selectedPart !== undefined"> -->
                  <span
                    :class="{ 'full-width': reporter.isObjectLeader }"
                    v-for="reporter in objectReporters"
                    :key="`addedReporter-${reporter._id}`"
                  >
                    <span
                      v-if="reporter.isObjectLeader"
                      class="tms tms-leader tms-leader--active"
                      >#</span
                    >
                    {{ reporter.name }}</span
                  >
                  <!-- </template> -->
                  <!-- <template v-else>
                    <span
                      v-for="reporter in newPart.reporters"
                      :key="`addedReporter-${reporter._id}`"
                      >{{ reporter.name }}</span
                    >
                  </template> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- БЮДЖЕТИ -->
        <div
          class="new-content-inputs new-content-inputs-bigger"
          v-if="getUser.permissions.isSuperAdmin"
        >
          <!-- БЮДЖЕТ ПО ДОГОВОР -->
          <template
            v-if="selectedObject !== undefined || newPart.activities.length"
          >
            <div class="new-input-wrapper">
              <label for>
                <strong>{{
                  `${$t("budget-contract")} ${$t("for")} ${$t("site")}`
                }}</strong>
              </label>
              <div class="new-input">
                <span class="tms2">a</span>
                <input
                  type="text"
                  :placeholder="$t('budget-contract')"
                  :value="budget.contract"
                  disabled="true"
                />
                <span class="disabled">A</span>
              </div>
            </div>
            <div class="new-input-wrapper">
              <label for>
                <strong>{{
                  `${$t("budget-company")} ${$t("for")} ${$t("site")}`
                }}</strong>
              </label>
              <div class="new-input">
                <span class="tms2">a</span>
                <input
                  type="text"
                  :placeholder="$t('budget-company')"
                  :value="budget.company"
                  disabled="true"
                />
                <span class="disabled">A</span>
              </div>
            </div>
            <div class="new-input-wrapper">
              <label for>
                <strong>{{
                  `${$t("budget-total")} ${$t("for")} ${$t("site")}`
                }}</strong>
              </label>
              <div class="new-input">
                <span class="tms2">a</span>
                <input
                  type="text"
                  :placeholder="$t('budget-total')"
                  disabled
                  :value="budget.total"
                />
                <span class="disabled">A</span>
              </div>
            </div>
          </template>
        </div>

        <!-- BUTONS MOBILE -->
        <div class="btns mobile">
          <button class="btn btn-close" @click="goBack">
            <span class="tms">F</span>
            {{ $t("cancel") }}
          </button>
          <button class="btn btn-new" @click="save()">
            <span class="tms">Y</span>
            {{ $t("save") }}
          </button>
        </div>
        <!-- BUTTON DELETE -->
        <!-- <div class="delete-wrapper">
          <button class="btn btn-delete" v-if="company._id" @click="deleteCompany()">
            <span class="tms">b</span>Изтриване на фирма
          </button>
        </div>-->
      </div>
    </div>

    <template v-if="currentParts.length">
      <div
        class="new-wrapper"
        :class="{ 'new-wrapper_part--inactive': !p.isActive }"
        v-for="(p, i) in currentParts"
        v-show="p.isActive === showActive"
        :key="`op-${i}`"
        :ref="`part-${i}`"
      >
        <div class="new-content">
          <div
            class="new-content-inputs new-content-inputs-bigger new-content--first-big"
          >
            <template
              v-if="
                selectedObject !== undefined ||
                (company._id && searchObjects.length)
              "
            >
              <div class="new-input-wrapper">
                <label for class="label-wrap">
                  <strong>Част</strong>
                  <div class="switch-wrapper">
                    <div class="switch-container switch-container--new">
                      <label class="switch">
                        <input
                          type="checkbox"
                          v-model="p.isActive"
                          @change="companyChanged(), (p.updateInReports = true)"
                        />
                        <span class="slider"></span>
                      </label>
                    </div>
                    <label
                      class="switch-label"
                      :class="{ 'switch-label--active': p.isActive }"
                      >{{
                        $t(`${p.isActive ? "active" : "inactive"}-part`)
                      }}</label
                    >
                  </div>
                </label>
                <div
                  class="new-input"
                  :class="{ 'new-input--flash': flashLastPart === i }"
                >
                  <span class="tms2">a</span>
                  <input
                    type="text"
                    placeholder="Име на частта"
                    v-model="p.partName"
                    @focus="flashLastPart = false"
                    :disabled="p._id"
                  />
                  <span class="disabled" v-if="p._id">A</span>
                </div>
              </div>
              <template v-if="getUser.permissions.isSuperAdmin">
                <div class="new-input-wrapper">
                  <label for>
                    <strong>{{
                      `${$t("budget-contract")} ${$t("for")} ${$t("site")}`
                    }}</strong>
                  </label>
                  <div class="new-input">
                    <span class="tms2">a</span>
                    <input
                      type="text"
                      :placeholder="$t('budget-contract')"
                      :value="formatNums(p.budgetContract)"
                      disabled="true"
                    />
                    <span class="disabled">A</span>
                  </div>
                </div>
                <div class="new-input-wrapper">
                  <label for>
                    <strong>{{
                      `${$t("budget-company")} ${$t("for")} ${$t("site")}`
                    }}</strong>
                  </label>
                  <div class="new-input">
                    <span class="tms2">a</span>
                    <input
                      type="text"
                      :placeholder="$t('budget-company')"
                      :value="formatNums(p.budgetCompany)"
                      disabled="true"
                    />
                    <span class="disabled">A</span>
                  </div>
                </div>
                <div class="new-input-wrapper">
                  <label for>
                    <strong>{{
                      `${$t("budget-total")} ${$t("for")} ${$t("site")}`
                    }}</strong>
                  </label>
                  <div class="new-input">
                    <span class="tms2">a</span>
                    <input
                      type="text"
                      :placeholder="$t('budget-total')"
                      disabled
                      :value="formatNums(p.budgetTotal)"
                    />
                    <span class="disabled">A</span>
                  </div>
                </div>
              </template>
            </template>
          </div>
          <!-- <div
          class="new-content-data-row desktop"
          v-if="selectedPart !== undefined || searchParts.length"
        >
          <div class="new-content-data-item">
            <div
              class="new-content-data-item-toggle"
              @click="isAddUsersModalOpened = true"
            >
              <p>{{ $t("add-reporters-and-leaders") }}</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="tms">V</span>
              </span>
            </div>
          </div>
          <div class="new-content-data-item">
            <div
              class="new-content-data-item-toggle"
              @click="isAddMaterialsModalOpened = true"
            >
              <p>{{ $t("add-materials") }}</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="tms">T</span>
              </span>
            </div>
          </div>
          <div class="new-content-data-item">
            <div
              class="new-content-data-item-toggle"
              @click="isAddActivitiesModalOpened = true"
            >
              <p>{{ $t("add-activities") }}</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="tms">U</span>
              </span>
            </div>
          </div>
        </div> -->
          <!-- MOBILE REPORTERS / MATERIALS / ACTIVITIES / MECHANIZATIONS -->
          <!-- <div
            class="new-content-data-row mobile"
            v-if="selectedPart !== undefined || searchParts.length"
          >
            <div class="new-content-data-item">
              <div
                class="new-content-data-item-toggle mobile"
                @click="isAddMaterialsModalOpened = true"
              >
                <p>{{ $t("add-materials") }}</p>
                <span class="new-content-data-item-toggle-circle">
                  <span class="tms">T</span>
                </span>
              </div>
            </div>
            <div class="new-content-data-item">
              <div
                class="new-content-data-item-toggle mobile"
                @click="isAddActivitiesModalOpened = true"
              >
                <p>{{ $t("add-activities") }}</p>
                <span class="new-content-data-item-toggle-circle">
                  <span class="tms">U</span>
                </span>
              </div>
            </div>
          </div> -->

          <!-- REPORTERS / MATERIALS / ACTIVITIES / MECHANIZATIONS -->
          <div
            class="new-content-data-row new-content-data-row-fullsize"
            v-if="viewLists()"
            :class="{ 'new-content-data-row-active': viewLists() }"
          >
            <!-- ACTIVITIES -->
            <div class="new-content-data-item">
              <div
                class="new-content-data-item-toggle"
                @click="isAddActivitiesModalOpened = p"
              >
                <p>{{ $t("activities") }}</p>
                <!-- <p class="ma-cell desktop"> {{ $t('metric-unit') }}</p>
              <p class="ma-cell desktop">{{ $t('real') }}</p>
              <p class="ma-cell desktop">{{ $t('planned') }}</p>
              <p class="ma-cell desktop">{{ $t('difference') }}</p>
              <p class="ma-cell desktop">{{ $t('earnings') }}</p>
              <p class="ma-cell desktop ma-cell-name--price">{{ $t('Price') }}</p> -->
                <span class="new-content-data-item-toggle-circle">
                  <span class="tms">U</span>
                </span>
              </div>
              <div v-if="viewLists()" class="new-content-data-item-content">
                <div class="new-content-data-item-content-lists">
                  <table v-if="p._id">
                    <thead>
                      <tr>
                        <td class="ma-cell">{{ $t("activities") }}</td>
                        <td class="ma-cell">{{ $t("metric-unit") }}</td>
                        <td class="ma-cell">{{ $t("real") }}</td>
                        <td class="ma-cell">{{ $t("planned") }}</td>
                        <td class="ma-cell">{{ $t("difference") }}</td>
                        <td class="ma-cell">{{ $t("earnings") }}</td>
                        <td class="ma-cell">{{ $t("Price") }}</td>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="!p.showAllActivities">
                        <tr
                          v-for="(activity, index) in p.activities.slice(
                            0,
                            showLength
                          )"
                          :key="`addedActivity-1-${index}`"
                        >
                          <td class="ma-cell ma-cell-name">
                            <span
                              class="additional-zap"
                              v-if="activity.isAdditional"
                              >⚡</span
                            >
                            <TheInput v-model="activity.name" type="textarea" />
                          </td>
                          <td class="ma-cell">{{ activity.unit }}</td>
                          <td class="ma-cell">
                            <p
                              class="hours-status"
                              :class="smrStatus(activity)"
                            >
                              {{ activity.totalUsed || 0 }}
                            </p>
                          </td>
                          <td class="ma-cell">
                            <TheInput
                              :digitsAndFloatOnly="true"
                              v-model="activity.quantity"
                            />
                          </td>
                          <td class="ma-cell">
                            {{
                              Number(
                                (activity.totalUsed || 0) - activity.quantity
                              ).toFixed(2)
                            }}
                          </td>
                          <td class="ma-cell">
                            <TheInput
                              :digitsAndFloatOnly="true"
                              v-model="activity.earnings"
                            />
                          </td>
                          <td class="ma-cell">
                            <TheInput
                              :digitsAndFloatOnly="true"
                              v-model="activity.price"
                            />
                            <!-- {{(+activity.price).toFixed(2)}} {{ $t('currency') }} -->
                          </td>
                        </tr>
                        <tr v-if="p.activities.length > showLength">
                          <td colspan="3">
                            <a
                              class="show-all"
                              @click="$set(p, 'showAllActivities', true)"
                              >{{ $t("show-all") }}</a
                            >
                          </td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr
                          v-for="(activity, index) in p.activities"
                          :key="`addedActivity-2-${index}`"
                        >
                          <td class="ma-cell ma-cell-name">
                            <span
                              class="additional-zap"
                              v-if="activity.isAdditional"
                              >⚡</span
                            >
                            <TheInput v-model="activity.name" type="textarea" />
                          </td>
                          <td class="ma-cell">{{ activity.unit }}</td>
                          <td class="ma-cell">
                            <p
                              class="hours-status"
                              :class="smrStatus(activity)"
                            >
                              {{ activity.totalUsed || 0 }}
                            </p>
                          </td>
                          <td class="ma-cell">
                            <TheInput
                              :digitsAndFloatOnly="true"
                              v-model="activity.quantity"
                            />
                          </td>
                          <td class="ma-cell">
                            {{
                              Number(
                                (activity.totalUsed || 0) - activity.quantity
                              ).toFixed(2)
                            }}
                          </td>
                          <td class="ma-cell">
                            <TheInput
                              :digitsAndFloatOnly="true"
                              v-model="activity.earnings"
                            />
                          </td>
                          <td class="ma-cell">
                            <TheInput
                              :digitsAndFloatOnly="true"
                              v-model="activity.price"
                            />
                            <!-- {{(+activity.price).toFixed(2)}} {{ $t('currency') }} -->
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <table v-else>
                    <tr
                      v-for="(activity, index) in newPart.activities"
                      :key="`addedActivity-3-${index}`"
                    >
                      <td class="ma-cell ma-cell-name">{{ activity.name }}</td>
                      <td class="ma-cell">{{ activity.unit }}</td>
                      <td class="ma-cell"></td>
                      <td class="ma-cell">{{ activity.quantity }}</td>
                      <td class="ma-cell">{{ activity.earnings || 0 }}</td>
                      <td class="ma-cell">
                        {{ (+activity.price).toFixed(2) }} {{ $t("currency") }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <!-- MATERIALS -->
            <div class="new-content-data-item">
              <div
                class="new-content-data-item-toggle"
                @click="isAddMaterialsModalOpened = p"
              >
                <p>{{ $t("Materials") }}</p>
                <span class="new-content-data-item-toggle-circle">
                  <span class="tms">T</span>
                </span>
              </div>
              <div v-if="viewLists()" class="new-content-data-item-content">
                <div class="new-content-data-item-content-lists">
                  <table v-if="p._id">
                    <thead>
                      <tr>
                        <td class="ma-cell">{{ $t("Materials") }}</td>
                        <td class="ma-cell">{{ $t("metric-unit") }}</td>
                        <td class="ma-cell">{{ $t("Price") }}</td>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="!p.showAllMaterials">
                        <tr
                          v-for="(material, index) in p.materials.slice(
                            0,
                            showLength
                          )"
                          :key="`addedMaterial-${index}-${material.name}`"
                        >
                          <td class="ma-cell ma-cell-name">
                            <span
                              class="additional-zap"
                              v-if="material.isAdditional"
                              >⚡</span
                            >
                            <TheInput v-model="material.name" type="textarea" />
                          </td>
                          <td class="ma-cell">{{ material.unit }}</td>
                          <td class="ma-cell">
                            <TheInput
                              :digitsAndFloatOnly="true"
                              v-model="material.price"
                            />
                            <!-- {{(+material.price).toFixed(2)}} {{ $t('currency') }} -->
                          </td>
                        </tr>
                        <tr v-if="p.materials.length > showLength">
                          <td colspan="3">
                            <a
                              class="show-all"
                              @click="$set(p, 'showAllMaterials', true)"
                              >{{ $t("show-all") }}</a
                            >
                          </td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr
                          v-for="(material, index) in p.materials"
                          :key="`addedMaterial-${index}-${material.name}`"
                        >
                          <td class="ma-cell ma-cell-name">
                            <span
                              class="additional-zap"
                              v-if="material.isAdditional"
                              >⚡</span
                            >
                            <TheInput v-model="material.name" type="textarea" />
                          </td>
                          <td class="ma-cell">{{ material.unit }}</td>
                          <td class="ma-cell">
                            <TheInput
                              :digitsAndFloatOnly="true"
                              v-model="material.price"
                            />
                            <!-- {{(+material.price).toFixed(2)}} {{ $t('currency') }} -->
                          </td>
                        </tr>
                        <!-- <td colspan="3"><a class="show-all" @click="showLessMaterials = true">Покажи първите {{ showLength }}</a></td> -->
                      </template>
                    </tbody>
                  </table>
                  <table v-else>
                    <tr
                      v-for="(material, index) in newPart.materials"
                      :key="`addedMaterial-${index}-${material.name}`"
                    >
                      <td class="ma-cell ma-cell-name">{{ material.name }}</td>
                      <td class="ma-cell">{{ material.unit }}</td>
                      <td class="ma-cell">
                        {{ (+material.price).toFixed(2) }} {{ $t("currency") }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- ADD BUDGET MODAL -->
    <transition name="fade">
      <AddBudgetModal v-if="isAddBudgetModalOpened" />
    </transition>
    <!-- ADD REPORTERS MODAL -->
    <transition name="fade">
      <AddUsersModal
        v-if="isAddUsersModalOpened"
        :incomingUsers="getReportersForModal()"
        :isCommingFromCompany="true"
        :usersType="'reporters'"
      />
    </transition>
    <!-- ADD MATERIALS MODAL -->
    <transition name="fade">
      <AddMaterialsModal
        v-if="isAddMaterialsModalOpened"
        :incomingMaterials="isAddMaterialsModalOpened.materials"
      />
    </transition>
    <!-- ADD ACTIVITIES MODAL -->
    <transition name="fade">
      <AddActivitiesModal
        v-if="isAddActivitiesModalOpened"
        :incomingActivities="isAddActivitiesModalOpened.activities"
        :incomingBudget="
          isAddActivitiesModalOpened
            ? Number(isAddActivitiesModalOpened.budgetContract)
            : 0
        "
      />
    </transition>
    <!-- ADD MECHANIZATIONS MODAL -->
    <transition name="fade">
      <AddMechanizationsModal
        v-if="isAddMechanizationsModalOpened"
        :incomingMechanizations="getMechanizationsForModal()"
      />
    </transition>
    <!-- ADD ACTIVITIES MODAL -->
    <transition name="fade">
      <EditInputModal
        v-if="isEditInputModalOpened"
        :inputForEdit="inputForEdit"
        :isComingFromCompany="true"
        :nameToEdit="nameToEdit"
        @create="save"
        @edit="save"
        @close="closeEditInputModal"
      />
    </transition>
    <transition name="fade">
      <UnsavedChangesModal v-if="isUnsavedChangesModalOpened" />
    </transition>
  </div>
</template>

<script>
import AddBudgetModal from "./shared/AddBudgetModal";
import AddUsersModal from "./shared/AddUsersModal";
import AddMaterialsModal from "./shared/AddMaterialsModal";
import AddActivitiesModal from "./shared/AddActivitiesModal";
import AddMechanizationsModal from "./shared/AddMechanizationsModal";
import EditInputModal from "./shared/EditInputModal";
import UnsavedChangesModal from "./shared/UnsavedChangesModal";
import TheInput from "./shared/TheInput";
import log from "./mixins/log.js";
export default {
  components: {
    AddUsersModal: AddUsersModal,
    AddMaterialsModal: AddMaterialsModal,
    AddActivitiesModal: AddActivitiesModal,
    AddMechanizationsModal: AddMechanizationsModal,
    UnsavedChangesModal: UnsavedChangesModal,
    EditInputModal: EditInputModal,
    AddBudgetModal,
    TheInput,
  },
  mixins: [log],
  props: ["idToEdit", "showActive"],
  computed: {
    objectReporters() {
      // if (this.company && this.selectedObject && this.selectedPart) {
      if (this.company && this.selectedObject) {
        // eslint-disable-next-line
        return this.company.objects[this.selectedObject].reporters.sort((a) =>
          a.isObjectLeader ? -1 : 1
        );
      } else if (this.company && this.selectedObject !== null) {
        return this.newObject.reporters.sort((a) =>
          a.isObjectLeader ? -1 : 1
        );
      }
      return [];
    },
    currentParts() {
      if (
        this.company._id &&
        this.selectedObject === undefined &&
        this.searchObjects.length
      ) {
        return [this.newPart];
      }

      return this.selectedObject !== undefined
        ? this.selectedPart !== undefined
          ? this.company.objects[this.selectedObject].parts
          : [...this.company.objects[this.selectedObject].parts, this.newPart]
        : this.newObject.parts;
    },
    budget() {
      let b = {
        contract: 0,
        company: 0,
        total: 0,
      };
      if (this.selectedObject) {
        for (let p of this.company.objects[this.selectedObject].parts) {
          b.contract += +p.budgetContract;
          b.company += +p.budgetCompany;
          b.total += +p.budgetTotal;
        }
      }

      b.contract = this.formatNums(b.contract);
      b.company = this.formatNums(b.company);
      b.total = this.formatNums(b.total);

      return b;
    },
  },
  watch: {
    "$route.path"() {
      this.setRoutes();
    },
    $route() {
      this.showLessActivities = true;
      this.showLessMechanizations = true;
    },
  },
  data() {
    return {
      isCompanyChanged: false,
      flashLastPart: false,
      incomingActivities: [],
      incomingMaterials: [],
      incomingMechanizations: [],
      // А boolean for every dropdown in the template
      openedDropdown: [false, false, false, false],
      // Booleans for reporters/materials/activies/ selections modals
      isAddBudgetModalOpened: false,
      isAddUsersModalOpened: false,
      isAddMaterialsModalOpened: false,
      isAddActivitiesModalOpened: false,
      isAddMechanizationsModalOpened: false,
      isEditInputModalOpened: false,
      isUnsavedChangesModalOpened: false,
      showLength: 10,
      showLessActivities: true,
      nameToEdit: "",
      showLessMechanizations: true,
      inputForEdit: {
        value: "",
        where: "",
      },
      isActive: true,
      // selectedProject: undefined,
      selectedObject: undefined,
      selectedPart: undefined,
      // SELECTED ARRAYS
      selectedReporters: [],
      selectedMaterials: [],
      selectedActivities: [],
      selectedMechanizations: [],
      // SEARCH
      searchCompanies: "",
      // searchProjects: '',
      searchObjects: "",
      searchParts: "",
      // The main company object
      companies: [],
      users: [],
      // The specific company object
      company: {
        _id: undefined,
        companyName: "",
        // budgetContract: 0,
        // budgetCompany: 0,
        objects: [
          {
            objectName: "",
            reporters: [],
            parts: [
              {
                budgetContract: 0,
                budgetCompany: 0,
                isActive: true,
                partName: "",
                materials: [],
                activities: [],
                mechanizations: [],
              },
            ],
          },
        ],
      },
      newObject: {
        objectName: "",
        reporters: [],
        parts: [],
      },
      newPart: {
        partName: "",
        isActive: true,
        materials: [],
        activities: [],
        mechanizations: [],
        // parts: [],
        budgetContract: 0,
        budgetCompany: 0,
      },
      newPartOLD: {
        partName: "",
      },
    };
  },
  methods: {
    formatNums(n = 0) {
      let num = parseFloat(n).toFixed(2);
      let parts = num.toString().split(".");

      if (typeof parts !== "undefined") {
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        let formated = parts.join(".");
        return formated + ` ${this.$t("currency")}`;
      } else {
        return `0 ${this.$t("currency")}`;
      }
    },
    // getBudgetContract() {
    //   this.budgetContract = parseFloat(
    //     this.company.objects[this.selectedObject].parts[this.selectedPart]
    //       .budgetContract
    //   );
    // },
    formatBudgetContract() {
      if (Number.isNaN(parseFloat(this.budgetContract))) {
        this.budgetContract = 0;
      }
      this.budgetContract = this.formatNums(this.budgetContract);
    },
    getBudgetCompany() {
      this.budgetCompany = parseFloat(
        this.company.objects[this.selectedObject].parts[this.selectedPart]
          .budgetCompany
      );
    },
    formatBudgetCompany() {
      if (Number.isNaN(parseFloat(this.budgetCompany))) {
        this.budgetCompany = 0;
      }
      this.budgetCompany = this.formatNums(this.budgetCompany);
    },
    getObjectSmrTotals() {
      let object = this.company.objects[this.selectedObject];
      let part = object.parts[this.selectedPart];
      if (object && part) {
        let requestUrl = `${process.env.VUE_APP_BASE_URI}/report/totalSmr/${this.company._id}/${object._id}/${part._id}`;
        this.$http
          .get(requestUrl)
          .then((res) => {
            if (res.data) {
              this.company.objects[this.selectedObject].parts[
                this.selectedPart
              ].activities = res.data;
              this.company.objects[this.selectedObject].parts[
                this.selectedPart
              ].activities.sort(this.sortByIsAdditional);
              this.company.objects[this.selectedObject].parts[
                this.selectedPart
              ].materials.sort(this.sortByIsAdditional);
            }
          })
          .catch((error) => console.log(error));
      }
    },
    sortByIsAdditional(a, b) {
      if (a.isAdditional === true) {
        return 1; // a is considered greater (pushed to the end)
      }
      if (b.isAdditional === true) {
        return -1; // b is considered greater (pushed to the end)
      }
    },
    smrStatus(a) {
      if (Number(a.totalUsed) === Number(a.plannedHours))
        return "hours-status--green";
      if (Number(a.totalUsed) > Number(a.plannedHours))
        return "hours-status--orange";
      else return "hours-status--red";
    },
    initBudgets() {
      if (this.selectedPart !== undefined) {
        // this.getBudgetContract();
        // this.formatBudgetContract();
        // this.getBudgetCompany();
        // this.formatBudgetCompany();
        this.getTotal(this.company._id);
        this.getPartBudget();
      }
    },
    // DROPDOWNS
    openDropdown(i) {
      this.$set(this.openedDropdown, i, true);
    },
    closeDropdown(i) {
      setTimeout(() => {
        this.$set(this.openedDropdown, i, false);
      }, 100);
    },
    // isObjectActive() {
    //   if (
    //     this.selectedObject !== undefined &&
    //     this.selectedPart !== undefined
    //   ) {
    //     return this.company.objects[this.selectedObject].parts[
    //       this.selectedPart
    //     ].isActive;
    //   }
    //   return this.newPart.isActive;
    // },
    // SELECTING
    // 1 - SELECT COMPANY BY ID
    selectCompany(id) {
      this.selectedObject = undefined;
      this.selectedPart = undefined;
      this.getCompany(id);
    },
    // 2 - SELECT THE INDEX OF A 'PROJECT' INSIDE COMPANY
    selectProject(project) {
      this.selectedPart = undefined;
      this.selectedObject = project;
    },
    // 3 - SELECT THE INDEX OF AN 'OBJECT' INSIDE A PROJECT
    selectObject(object) {
      // this.selectedPart = undefined;
      this.selectedObject = object;
      // this.getObjectBudget()
    },
    // 4 - SELECT THE INDEX OF A 'PART' INSIDE AN OBJECT
    selectPart(part) {
      this.selectedPart = part;
      this.getPartBudget();
    },
    // RESET SELECTED AND EVERYTHING NESTED INSIDE ON FOCUS
    resetSelectedCompany() {
      this.company = {
        companyName: "",
        objects: [
          {
            _id: "",
            objectName: "",
            reporters: [],
            parts: [
              {
                _id: "",
                isActive: true,
                partName: "",
                materials: [],
                activities: [],
                mechanizations: [],
                // parts: [],
                budgetContract: 0,
                budgetCompany: 0,
              },
            ],
          },
        ],
      };
      // this.newObject = {
      //   projectName: '',
      //   objects: []
      // };
      this.newPartOLD = {
        objectName: "",
        isActive: true,
        materials: [],
        activities: [],
        mechanizations: [],
        // parts: []
      };
      // this.newPartOLD = {
      //   partName: ''
      // };
      this.searchCompanies = "";
      // this.resetSelectedProject();
      this.resetSelectedObject();
    },
    // resetSelectedObject
    // resetSelectedProject() {
    //   this.selectedObject = undefined;
    //   this.searchObjects = '';
    //   this.resetSelectedObject();
    // },
    // resetSelectedPART
    resetSelectedObject() {
      this.selectedObject = undefined;
      this.searchObjects = "";
      this.resetSelectedPart();
      // this.getObjectBudget()
    },
    resetSelectedPart() {
      this.selectedPart = undefined;
      this.searchParts = "";
      this.getPartBudget();
    },
    // FILTERED RESULTS WHEN SEARCHING
    filteredCompanies() {
      return this.companies.filter((c) => {
        return c.companyName
          .toLowerCase()
          .includes(this.searchCompanies.toLowerCase());
      });
    },
    // filteredProjects() {
    //   return this.company.projects.filter(p => {
    //     return p.projectName
    //       .toLowerCase()
    //       .includes(this.searchProjects.toLowerCase());
    //   });
    // },
    filteredObjects() {
      return this.company.objects.filter((p) => {
        return p.objectName
          .toLowerCase()
          .includes(this.searchObjects.toLowerCase());
      });
    },
    filteredParts() {
      if (this.selectedObject !== undefined) {
        return this.company.objects[this.selectedObject].parts.filter((o) => {
          return o.partName
            .toLowerCase()
            .includes(this.searchParts.toLowerCase());
        });
      }
    },
    // RETURN IF REPORTERS/MATERIALS/ACTIVITIES SECTION SHOULD BE VISIBLE
    viewLists() {
      // const reporters =
      //   this.selectedObject !== undefined
      //     ? this.company.objects[this.selectedObject].reporters
      //     : this.newObject.reporters;

      // if (this.selectedPart !== undefined) {
      //   let path =
      //     this.company.objects[this.selectedObject].parts[this.selectedPart];
      //   return (
      //     reporters.length ||
      //     path.materials.length ||
      //     path.mechanizations.length ||
      //     path.activities.length
      //   );
      // } else {
      //   // return true;
      //   return (
      //     reporters.length ||
      //     this.newPart.materials.length ||
      //     this.newPart.mechanizations.length ||
      //     this.newPart.activities.length
      //   );
      // }
      return (
        this.selectedObject !== undefined ||
        (this.company._id &&
          this.selectedObject === undefined &&
          this.searchObjects.length)
      );
    },
    getReportersForModal() {
      if (this.selectedObject === undefined) {
        return this.newObject.reporters;
      } else {
        return this.company.objects[this.selectedObject].reporters;
      }
    },
    // getMaterialsForModal() {
    //   if (this.selectedPart === undefined) {
    //     return this.newPart.materials;
    //   } else {
    //     return this.company.objects[this.selectedObject].parts[
    //       this.selectedPart
    //     ].materials;
    //   }
    // },
    // getActivitiesForModal() {
    //   if (this.selectedPart === undefined) {
    //     return this.newPart.activities;
    //   } else {
    //     return this.company.objects[this.selectedObject].parts[
    //       this.selectedPart
    //     ].activities;
    //   }
    // },
    getMechanizationsForModal() {
      if (this.selectedPart === undefined) {
        return this.newPart.mechanizations;
      } else {
        return this.company.objects[this.selectedObject].parts[
          this.selectedPart
        ].mechanizations;
      }
    },
    // HANDLE THE REPORTERS/MATERIALS/ACTIVITIES/MECHANIZATIONS RETURNED FROM THE MODALS
    // If we get the 'saveAddUsersModal' event, we assign the workers we receive to the selected/new part
    handleReporters(reporters) {
      if (this.selectedObject === undefined) {
        this.newObject.reporters = reporters;
      } else {
        this.company.objects[this.selectedObject].reporters = reporters;
      }
      this.closeAddUsersModal();
      this.companyChanged();
    },
    // If we get the 'saveAddMaterialsModal' event, we assign the materials we receive to the selected/new part
    handleMaterials(materials) {
      materials.sort(this.sortByIsAdditional);
      this.isAddMaterialsModalOpened.materials = materials;
      this.closeAddMaterialsModal();
      this.companyChanged();
    },
    handleBudget(budget) {
      (this.budgetContract = budget),
        (this.budgetCompany = budget - budget / 10);

      if (this.selectedPart === undefined) {
        this.newPart.budgetContract = parseFloat(this.budgetContract).toFixed(
          2
        );
        this.newPart.budgetCompany = parseFloat(this.budgetCompany).toFixed(2);
      }
      this.company.objects[this.selectedObject || 0].parts[
        this.selectedPart || 0
      ].budgetContract = parseFloat(this.budgetContract).toFixed(2);
      this.budgetContract = this.formatNums(this.budgetContract);
      this.company.objects[this.selectedObject || 0].parts[
        this.selectedPart || 0
      ].budgetCompany = parseFloat(this.budgetCompany).toFixed(2);
      this.budgetCompany = this.formatNums(this.budgetCompany);
      this.isAddBudgetModalOpened = false;
    },
    // If we get the 'saveAddActivitiesModal' event, we assign the activities we receive to the selected/new part
    handleActivities(activities, budget) {
      this.getPartBudget(budget);
      // if (budget) this.handleBudget(budget);
      activities.sort(this.sortByIsAdditional);

      this.isAddActivitiesModalOpened.activities = activities;
      this.closeAddActivitiesModal();
      this.companyChanged();
    },
    // If we get the 'saveAddMechanizationsModal' event, we assign the mechanizations we receive to the selected/new part
    handleMechanizations(mechanizations) {
      if (this.selectedPart === undefined) {
        this.newPart.mechanizations = mechanizations;
      } else {
        this.company.objects[this.selectedObject].parts[
          this.selectedPart
        ].mechanizations = mechanizations;
      }
      this.closeAddMechanizationsModal();
      this.companyChanged();
    },
    // If we get the 'saveEditInputModal' event, we change the name of the field we need to change
    handleEdit(edited) {
      if (edited.where === "company") {
        this.company.companyName = edited.value;
        if (edited.shortName) this.company.shortName = edited.shortName;
        this.$snotify.warning(
          `${this.$t("successfully-edited")} ${this.$t(
            "company"
          ).toLowerCase()}. ${this.$t("to-save-click-save")}`
        );
      } else if (edited.where === "object") {
        this.company.objects[this.selectedObject].objectName = edited.value;
        if (edited.shortName)
          this.company.objects[this.selectedObject].shortName =
            edited.shortName;
        this.$snotify.warning(
          `${this.$t("successfully-edited")} ${this.$t(
            "site"
          ).toLowerCase()}. ${this.$t("to-save-click-save")}`
        );
      } else if (edited.where === "part") {
        this.company.objects[this.selectedObject].parts[
          this.selectedPart
        ].partName = edited.value;
        this.$snotify.warning(
          `${this.$t("successfully-edited")} ${this.$t(
            "part"
          ).toLowerCase()}. ${this.$t("to-save-click-save")}`
        );
      }
      // else if (edited.where === 'part') {
      //   this.company.objects[this.selectedObject].parts[
      //     this.selectedPart
      //   ].parts[this.selectedPart].partName = edited.value;
      //   this.$snotify.warning(
      //     `${this.$t(
      //       'successfully-edited'
      //     )} ${this.$t('part').toLowerCase() }. ${ this.$t('to-save-click-save')}`
      //   );
      // }
      this.closeEditInputModal();
      this.companyChanged();
    },
    // Close the modals when we got the corresponding event
    closeAddBudgetModal() {
      this.isAddBudgetModalOpened = false;
    },
    closeAddUsersModal() {
      this.isAddUsersModalOpened = false;
    },
    closeAddMaterialsModal() {
      this.isAddMaterialsModalOpened = false;
    },
    closeAddActivitiesModal() {
      this.isAddActivitiesModalOpened = false;
    },
    closeAddMechanizationsModal() {
      this.isAddMechanizationsModalOpened = false;
    },
    closeEditInputModal() {
      this.isEditInputModalOpened = false;
      this.nameToEdit = "";
    },
    toggleEdit(value, where, shortName) {
      this.inputForEdit = {
        value: value,
        shortName: shortName,
        where: where,
      };

      this.nameToEdit = value;
      this.isEditInputModalOpened = true;
    },
    getPartBudget() {
      setTimeout(() => {
        if (this.selectedObject === undefined) return;
        let object = this.company.objects[this.selectedObject];
        for (let part of object.parts) {
          let budget = 0;
          if (part) {
            part.activities.map((a) => {
              if (a.quantity && a.price) budget += a.quantity * a.price;
            });
          }

          this.$set(part, "budgetContract", budget);
          this.$set(part, "budgetCompany", budget - budget / 10);
          // this.handleBudget(budget);
        }
      }, 100);
    },
    // REQUESTS
    // GET ALL COMPANIES REQUEST

    getTotal(id) {
      let object = this.company.objects[this.selectedObject];
      if (object && object.parts.length) {
        for (let p of object.parts) {
          let requestUrl = `${process.env.VUE_APP_BASE_URI}/report/total/${id}/${object._id}/${p._id}`;
          this.$http
            .get(requestUrl)
            .then((response) => {
              this.$set(p, "budgetTotal", response.data.total);
            })
            .catch((error) => console.log(error));
        }
      }
    },
    getCompanies() {
      let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/names`;
      this.$http
        .get(requestUrl)
        .then((response) => {
          this.companies = response.data;
          // console.log(JSON.stringify(this.companies));
        })
        .catch((error) => console.log(error));
    },
    // GET SPECIFIC COMPANY BY ID REQUEST
    getCompany(companyId) {
      // this.resetSelectedProject();
      this.resetSelectedObject();
      let url = `${process.env.VUE_APP_BASE_URI}/company/${companyId}`;
      this.$http
        .get(url)
        .then((response) => {
          this.company = response.data;
          this.initBudgets();
        })
        .catch((error) => console.log(error));
    },
    // GET and SET Selected Company and Project
    getObject(companyId, objectId, newPart) {
      this.resetSelectedPart();
      let url = `${process.env.VUE_APP_BASE_URI}/company/${companyId}`;
      this.$http
        .get(url)
        .then((response) => {
          this.company = response.data;
          // this.initBudgets();
          for (let object in this.company.objects) {
            if (this.company.objects[object]._id == objectId) {
              // SET Project
              this.selectedObject = object;
            }
          }
          this.initBudgets();

          if (newPart) {
            this.company.objects[this.selectedObject].parts.push(this.newPart);
          }
        })
        .catch((error) => console.log(error));
    },
    // GET and SET Selected Company, Project and Object
    getPart(companyId, objectId, partId) {
      // this.resetSelectedPart();
      let url = `${process.env.VUE_APP_BASE_URI}/company/${companyId}`;
      this.$http
        .get(url)
        .then((response) => {
          this.company = response.data;
          // this.initBudgets();
          for (let object in this.company.objects) {
            if (this.company.objects[object]._id == objectId) {
              // SET Project
              this.selectedObject = object;
              for (let part in this.company.objects[object].parts) {
                if (
                  this.company.objects[this.selectedObject].parts[part]._id ===
                  partId
                ) {
                  // SET Object
                  this.selectedPart = part;
                }
              }
            }
          }
          this.getObjectSmrTotals();
          this.initBudgets();
        })
        .catch((error) => console.log(error));
    },
    companyChanged() {
      if (!this.isCompanyChanged) {
        this.isCompanyChanged = true;
        this.$snotify.warning(
          'Току що променихте фирмата, не забравяйте да натиснете бутона "Запази" ако искате да запазите промените си.'
        );
      }
    },
    save() {
      let dublicated = false;

      //companies
      this.companies.filter((n) => {
        if (
          n.companyName.toLowerCase() === this.searchCompanies.toLowerCase() &&
          !this.company.companyName
        ) {
          this.$snotify.error("Има вече фирма с такова име.");
          dublicated = true;
        }
      });
      //companies

      if (this.company._id && this.company.objects) {
        //projects and objects
        this.company.objects.filter((n) => {
          if (
            n.objectName.toLowerCase() === this.searchObjects.toLowerCase() &&
            this.selectedPart === undefined
          ) {
            this.$snotify.error("Има вече обект с такова име.");
            dublicated = true;
          }

          for (let o of n.parts) {
            if (
              this.company.objects[this.selectedObject] &&
              this.company.objects[
                this.selectedObject
              ].objectName.toLowerCase() === n.objectName.toLowerCase()
            ) {
              if (
                o.partName.toLowerCase() === this.searchParts.toLowerCase() &&
                this.selectedPart === undefined
              ) {
                this.$snotify.error("Има вече част с такова име.");
                dublicated = true;
              }
            }
          }
        });
        //projects and objects
      }

      // IF THERE IS NO SELECTED COMPANY WE'RE MAKING A BRAND NEW ONE
      if (!dublicated) {
        this.getPartBudget();

        if (!this.company._id && this.fieldsValidation()) {
          if (confirm(this.$t("new-company-confirm"))) {
            this.postCompany();
          }
          // IN ALL OTHER CASES WE'RE UPDATING AN EXISTING ONE
        } else if (this.company._id && this.fieldsValidationEdit()) {
          this.updateCompany();
        }
      }
    },
    checkForUnsavedData(next) {
      this.isUnsavedChangesModalOpened = true;
      this.$once("closeUnsavedChangesModal", (answer) => {
        // confirm
        if (answer) {
          next(false);
          this.save();
        }
        // decline
        else {
          next();
        }
        this.isUnsavedChangesModalOpened = false;
        this.isCompanyChanged = false;
      });
    },
    // POST COMPANY REQUEST
    postCompany() {
      this.company.companyName = this.searchCompanies;
      this.company.objects[0].objectName = this.searchObjects;
      this.company.objects[0].reporters = this.newObject.reporters;
      this.company.objects[0].parts[0].partName = this.searchParts;
      this.company.objects[0].parts[0].materials = this.newPart.materials;
      this.company.objects[0].parts[0].activities = this.newPart.activities;
      this.company.objects[0].parts[0].mechanizations =
        this.newPart.mechanizations;
      this.company.objects[0].parts[0].isActive = this.newPart.isActive;

      // if (this.searchParts.length) {
      //     this.company.objects[0].parts.push({
      //         partName: this.searchParts
      //       });
      // }
      let url = `${process.env.VUE_APP_BASE_URI}/company`;
      this.$http
        .post(url, this.company)
        .then(() => {
          this.$snotify.success(this.$t("successfully-added-new-company"));
          this.isCompanyChanged = false;
          this.newLog("newCompany", this.company.companyName);
          this.goBack();
        })
        .catch((error) => {
          console.log(error);
          this.$snotify.error(this.$t("something-went-wrong"));
        });
    },
    // UPDATE COMPANY REQUEST
    updateCompany() {
      // NEW PART
      if (this.selectedPart === undefined) {
        // * PART IS OPTIONAL
        if (this.searchParts.length) {
          this.newPart.partName = this.searchParts;
        }
        // NEW OBJECT
        if (this.selectedPart === undefined) {
          this.newPart.objectName = this.searchObjects;
          // * PART IS OPTIONAL
          // if (this.searchParts.length) {
          //   this.newPart.parts.push(this.newPartOLD);
          // }
          // NEW PROJECT
          if (this.selectedObject === undefined) {
            this.newObject.objectName = this.searchObjects;
            this.newObject.parts.push(this.newPart);
            this.company.objects.push(this.newObject);
          }
          // IF THERE IS SELECTED PROJECT PUSH THE NEW OBJECT TO IT
          else {
            this.company.objects[this.selectedObject].parts.push(this.newPart);
          }
        }
        // IF THERE IS SELECTED OBJECT PUSH THE NEW PART TO IT
        // else {
        //   // * PART IS OPTIONAL
        //   if (this.searchParts.length) {
        //     this.company.objects[this.selectedObject].parts[
        //       this.selectedPart
        //     ].parts.push({ partName: this.searchParts });
        //   }
        // }
      }

      // let requestObject = {
      //   _id: this.company._id,
      //   companyName: this.company.companyName,
      //   projects: []
      // };

      // if (this.selectedObject !== undefined) {
      //   requestObject.projects.push(
      //     this.company.projects[this.selectedObject]
      //   );
      // } else {
      //   requestObject.projects.push({
      //     projectName: this.searchProjects,
      //     objects: []
      //   });
      // }

      // if (this.selectedObject !== undefined && this.selectedPart !== undefined) {
      //   requestObject.projects[0].objects.push(
      //     this.company.objects[this.selectedObject].parts[this.selectedPart]
      //   );
      // } else {
      //   requestObject.projects[0].objects.push({
      //     objectName: this.searchObjects,
      //     parts: [],
      //     materials: this.newPart.materials,
      //     activities: this.newPart.activities,
      //     reporters: this.newPart.reporters,
      //     isActive: this.newPart.isActive
      //   });
      // }

      // if (this.selectedObject !== undefined && this.selectedPart !== undefined && this.selectedPart !== undefined) {
      //   requestObject.projects[0].objects[0].parts.push(
      //     this.company.objects[this.selectedObject].parts[this.selectedPart].parts
      //   );
      // } else {
      //   requestObject.projects[0].objects[0].parts.push({
      //     partName: this.searchParts,
      //   });
      // }

      // MAKE THE REQUEST
      let url = `${process.env.VUE_APP_BASE_URI}/company/${this.company._id}`;
      this.$http
        .put(url, this.company)
        .then(() => {
          this.$snotify.success(this.$t("success-changes"));
          this.isCompanyChanged = false;
          this.newLog("editCompany", this.company.companyName);
          this.goBack();
        })
        .catch((error) => {
          console.log(error);
          this.$snotify.error(this.$t("something-went-wrong"));
        });
    },
    deleteCompany() {
      if (this.company._id) {
        if (confirm(this.$t("delete-company-confirm"))) {
          this.$router.push("/companies");
          this.deleteCompanyRequest();
        }
      }
    },
    // deletePart() {
    //   if (this.company._id) {
    //     if (confirm(this.$t('delete-part-confirm'))) {

    //       this.company.objects[this.selectedObject].parts[this.selectedPart].parts.splice(this.selectedPart, 1)

    //       this.updateCompany()
    //       let projectId = this.company.projects[this.selectedObject]._id
    //       let objectId = this.company.objects[this.selectedObject].parts[this.selectedPart]._id

    //       this.getObject(this.company._id, projectId, objectId);
    //       this.$router.push(`/companies/${this.company._id}/${projectId}/${objectId}?removed=true`);
    //       this.$snotify.success(this.$t('successfully-deleted-part'))
    //     }
    //   }
    // },
    deleteCompanyRequest() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/${this.company._id}`;
      this.$http
        .delete(url)
        .then(this.$snotify.success(this.$t("successfully-deleted-company")))
        .catch((error) => {
          if (error.response.status == 404) {
            this.$snotify.error(this.$t("company-not-found"));
          } else {
            this.$snotify.error(this.$t("something-went-wrong"));
          }
        });
    },
    // CANCEL
    goBack() {
      this.$router.push("/companies");
    },
    fieldsValidation() {
      if (!this.searchCompanies) {
        this.$snotify.error(this.$t("please-add-company"));
        return false;
      }
      // if (!this.searchProjects) {
      //   this.$snotify.error(this.$t('please-add-project'));
      //   return false;
      // }
      if (!this.searchObjects) {
        this.$snotify.error(this.$t("please-add-site"));
        return false;
      }

      if (!this.searchParts) {
        this.$snotify.error(this.$t("please-add-part"));
        return false;
      }
      return true;
    },
    fieldsValidationEdit() {
      let object = this.company.objects[this.selectedObject];
      let part = object ? object.parts[this.selectedPart] : false;

      if (!this.company.companyName && !this.searchCompanies) {
        this.$snotify.error(this.$t("please-add-company"));
        return false;
      }
      if (!object && !this.searchObjects) {
        this.$snotify.error(this.$t("please-add-site"));
        return false;
      }
      if (!part && !this.newPart.partName) {
        this.$snotify.error(this.$t("please-add-part"));
        return false;
      }

      return true;
    },
    scrollToPart(byId) {
      setTimeout(() => {
        if (this.currentParts) {
          let index = this.currentParts.length - 1;

          if (byId) {
            let part = this.currentParts.find(
              (c) => c._id.toString() === byId.toString()
            );
            index = this.currentParts.indexOf(part);
          }

          this.flashLastPart = index;
          this.$refs[`part-${index}`][0].scrollIntoView({ behavior: "smooth" });

          setTimeout(() => {
            this.flashLastPart = false;
          }, 4000);
        }
      }, 300);
    },
    setRoutes() {
      // eslint-disable-next-line
      if (this.$route.name === "newCompany") {
      } else if (this.$route.name === "newObject") {
        this.getCompany(this.$route.params.companyId);
      } else if (this.$route.name === "newPart") {
        this.getObject(
          this.$route.params.companyId,
          this.$route.params.projectId
        );
        this.scrollToPart();
      }
      // else if (this.$route.name === 'newPartOLD') {
      //   this.getObject(
      //     this.$route.params.companyId,
      //     this.$route.params.projectId,
      //     this.$route.params.objectId
      //   );
      // }
      else if (this.$route.name === "getPart") {
        this.getPart(
          this.$route.params.companyId,
          this.$route.params.projectId,
          this.$route.params.objectId
        );
        this.scrollToPart(this.$route.params.objectId);
      }
    },
  },
  mounted() {
    this.setRoutes();
    this.getCompanies();
    // SAVE HANDLERS
    this.$on("saveAddUsersModal", this.handleReporters);
    this.$on("saveAddBudgetModal", this.handleBudget);
    this.$on("saveAddMaterialsModal", this.handleMaterials);
    this.$on("saveAddActivitiesModal", this.handleActivities);
    this.$on("saveAddMechanizationsModal", this.handleMechanizations);
    this.$on("saveEditInputModal", this.handleEdit);
    // CLOSE HANDLERS
    this.$on("closeAddBudgetModal", this.closeAddBudgetModal);
    this.$on("closeAddUsersModal", this.closeAddUsersModal);
    this.$on("closeAddMaterialsModal", this.closeAddMaterialsModal);
    this.$on("closeAddActivitiesModal", this.closeAddActivitiesModal);
    this.$on("closeAddMechanizationsModal", this.closeAddMechanizationsModal);
    this.$on("closeEditInputModal", this.closeEditInputModal);
  },
  beforeRouteLeave(to, from, next) {
    if (this.isCompanyChanged) {
      this.checkForUnsavedData(next);
    } else {
      next();
    }
  },
  destroyed() {
    // STOP LISTENING FOR THE EVENTS
    this.$off("saveAddUsersModal");
    this.$off("saveAddMaterialsModal");
    this.$off("saveAddBudgetModal");
    this.$off("saveAddActivitiesModal");
    this.$off("saveAddMechanizationsModal");
    this.$off("saveEditInputModal");
    this.$off("closeAddBudgetModal");
    this.$off("closeAddUsersModal");
    this.$off("closeAddMaterialsModal");
    this.$off("closeAddActivitiesModal");
    this.$off("closeAddMechanizationsModal");
    this.$off("closeEditInputModal");
  },
};
</script>

<style scoped lang="scss">
.tms-leader {
  vertical-align: middle;
  font-size: 16px;
  padding-right: 5px;
}
.label-wrap {
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 5px;
}
.title {
  color: #373737;
  font-size: 20px;
}
.new-content {
  width: 100%;
}
.new-project-container {
  align-items: center;
  margin-left: 40px;
  margin-right: 40px;
  margin-bottom: 27px;
}
.new-project-container-side-panel {
  margin-left: 24px;
  width: 70%;
}
.new-content-data-row-full-height {
  height: initial;
  margin-bottom: 10px;
}
.new-content-data-item {
  position: relative;
  height: 100%;

  &:hover {
    .banner {
      &.banner--hidden {
        opacity: 1;
      }
    }
  }
  .banner {
    align-items: center;
    background: #c0cce2;
    border: 1px solid #275371;
    border-radius: inherit;
    color: #275371;
    cursor: pointer;
    display: flex;
    gap: 10px;
    height: 100%;
    justify-content: center;
    text-align: center;
    transition: all 0.3s;
    position: absolute;
    width: 100%;

    &.banner--hidden {
      opacity: 0;
    }

    .tms {
      font-size: 40px;
    }

    p {
      font-size: 18px;
      font-weight: bold;
      max-width: 40%;
    }
  }

  .new-content-data-item-content-lists {
    > span {
      width: 25%;

      &.full-width {
        width: 100%;
      }
    }
  }
}
.new-project-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  padding-top: 11px;
}
.new-project-wrapper {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  width: 100%;
}
.title-and-excell {
  align-items: center;
  display: flex;
  gap: 20px;
}
.title-and-excell .btn-excel {
  margin-left: 0;
}
.buttons-wrapper {
  display: flex;
  flex-direction: row;
}
.switch-wrapper {
  align-items: center;
  display: flex;
}
.switch {
  margin: 0 10px;
}
.switch-label {
  color: #b40d0d;
  cursor: pointer;
  font-weight: 700;
  text-transform: uppercase;
  width: 60px;

  &.switch-label--active {
    color: #187413;
  }
}
.delete-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  width: 100%;
}
.show-all {
  color: #3b86ff;
  font-size: 11px;
  font-weight: 700;
  padding: 0 20px;
  text-decoration: underline;
}
.new-content-data-item-toggle-circle .tms2 {
  font-size: 18px;
}
.desktop {
  /* display: flex; */
}
.mobile {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: flex;
  }
  .projects-wrapper {
    justify-content: center;
  }
  .new-project-container-side-panel {
    width: 100%;
  }
  .new-input {
    margin: 5px 0;
  }
  .new-content-inputs {
    .new-content-data-row {
      padding: 0;

      .new-content-data-item {
        .banner {
          height: fit-content;
          min-height: 50px;

          .tms {
            font-size: 30px;
          }

          p {
            font-size: 15px;
            max-width: 80%;
          }
        }
      }
    }
  }
  .new-project-container {
    width: 92%;
    margin: 0 15px;
    margin-bottom: 27px;
  }
  .new-content-inputs {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  .new-input-wrapper {
    margin-right: 0px;
    width: 100%;
  }
  .new-project-header {
    justify-content: center;
  }
  .new-content-data-item-toggle.mobile {
    text-align: center;
    flex-direction: column;
    height: auto;
    padding-bottom: 0.6em;
  }
  .new-content-data-item-toggle.mobile p {
    margin-top: 0.6em;
    margin-bottom: 0.6em;
  }
  .btns.mobile {
    display: flex;
    justify-content: center;
    margin: 10px 0;
  }
  .delete-wrapper {
    justify-content: center;
  }
  .btn.btn-delete {
    width: 330px;
  }
  .new-content {
    width: 100%;
  }
  .new-content-data-item-content-lists > span {
    width: 30%;
  }
  .new-content-data-item-content-lists {
    overflow: auto;
  }
  .new-content-data-item-content .ma-cell {
    /* padding: 0px; */
    white-space: nowrap;
  }
  .new-content-data-item-content .ma-cell-name {
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .show-all {
    padding: 0;
  }
}
@media screen and (max-width: 600px) {
  .new-content-data-row {
    flex-wrap: wrap;
  }
  .new-content-data-item {
    width: calc(50% - 10px);
    margin-right: 20px;
  }
  .new-content-data-item:nth-child(even) {
    margin-right: 0;
  }
  .new-content-data-item:nth-child(1),
  .new-content-data-item:nth-child(2) {
    margin-bottom: 20px;
  }
  .new-content-data-row-fullsize .new-content-data-item {
    margin-right: 0;
    width: 100%;
  }
  .new-content-data-item-content-lists > span {
    padding: 5px 0;
    width: 100%;
  }
}
/* @media screen and (max-width: 340px) {
  .new-content-data-item {
    margin-right: 4px;
  }
} */
</style>
